import config from "../../config";

const model = {
  posts: {
    posts: [],
    page: config.paginationStartIndex,
    loading: false,
    error: false,
    calling: false
  },
  comments: {
    comments: [],
    page: config.paginationStartIndex,
    loading: false,
    error: false,
    calling: false
  }
};

export default model;
